/**
 * @desc 获取退货原因枚举列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/returnReasonEnum/getReturnReason`, {
      method: "GET",

      ...options,
    }),
  );
}
